import { getErrorString } from "./Error";

export class Logger {

	name : string;
	levelInfo : boolean = false;
	levelDebug : boolean = false;
	levelError : boolean = false;
	levelWarning : boolean = false;
	levelTrace : boolean = false;
	levelTraceWithStack : boolean = false;
	showLevel : boolean;


	constructor(name : string, showLevel : boolean, loglevels : string[]) {
		this.name = name;
		this.levelInfo = loglevels.indexOf('info') > -1;
		this.levelTrace = loglevels.indexOf('trace') > -1;
		this.levelTraceWithStack = loglevels.indexOf('trace-with-stack') > -1;
		this.levelDebug = loglevels.indexOf('debug') > -1;
		this.levelError = loglevels.indexOf('error') > -1;
		this.levelWarning = loglevels.indexOf('warn') > -1 || loglevels.indexOf('warning') > -1;
		this.showLevel = showLevel;

		this.info("Logger '" , this.name, "': levels ", loglevels);
	}

	private getStringFromObject(object : any) : string {
		if (typeof object == "string")
			return object;
		else if (typeof object == "number")
			return String(object);
		else
			return getErrorString(object);
	}

	private getString(level : string, ...data : any []) : string {
		let message : string;
		if (this.name.length == 0) {
			if (this.showLevel)
				message = level;
			else
				message = "";
		}
		else {
			if (this.showLevel)
				message = this.name + ": " + level;
			else
				message = this.name + ": ";
		}

		for (const object of data) {
			if (Array.isArray(object)) {
				console.log("Es ist ein Array");
				let array : any[] = <Array<any>>object;
				let first : boolean = true;
				for (const element of array) {
					if (first)
						first = false;
					else
						message += ", ";
					message += this.getStringFromObject(element);
				}
			}
			else
				message += this.getStringFromObject(object);
		}

		return message;
	}

	public info(callerIp : string, ...data: any []) : void {
		if (this.levelInfo)
			console.info(this.getString("INFO .... ", callerIp, ...data));
	}

	public debug(callerIp : string, ...data: any []) : void {
		if (this.levelDebug)
			console.debug(this.getString("DEBUG ... ", callerIp, ...data));
	}

	public trace(callerIp : string, ...data: any []) : void {
		if (this.levelTrace)
			console.debug(this.getString("TRACE ... ", callerIp, ...data));
	}

	public traceWithStack(callerIp : string, ...data: any []) : void {
		if (this.levelTraceWithStack)
			console.trace(this.getString("TRACE ... ", callerIp, ...data));
	}

	public warn(callerIp : string, ...data: any []) : void {
		if (this.levelWarning)
			console.warn('\x1b[33m%s\x1b[0m', this.getString("WARNING . ", callerIp, ...data));
	}

	public error(callerIp : string, ...data: any []) : string {
		if (this.levelError)
			console.error('\x1b[31m%s\x1b[0m', this.getString("ERROR ... ", callerIp, ...data));
		return this.getString("", ...data);
	}

}


// WEBPACK FOOTER //
// ./src/visionet/Logger.ts